import type { IKompisTranslations, ILocalizedInformation } from '@inter-ikea-kompis/types';

type IConfigurationSummaryToastMessage = {
	label: string;
};

export default class ConfigurationSummaryToastMessage {
	public static getAddToCartFail(
		localizedInformationOrTranslations: ILocalizedInformation | IKompisTranslations
	): IConfigurationSummaryToastMessage {
		const label =
			'translations' in localizedInformationOrTranslations
				? localizedInformationOrTranslations.translations.addToShoppingCartErrorMessage
				: localizedInformationOrTranslations.addToShoppingCartErrorMessage;

		return {
			label
		};
	}
	public static getAddToListFail(
		localizedInformationOrTranslations: ILocalizedInformation | IKompisTranslations
	): IConfigurationSummaryToastMessage {
		const label =
			'translations' in localizedInformationOrTranslations
				? localizedInformationOrTranslations.translations.addToShoppingListErrorMessage
				: localizedInformationOrTranslations.addToShoppingListErrorMessage;

		return {
			label
		};
	}
	public static getAddToCartAndListFail(
		localizedInformationOrTranslations: ILocalizedInformation | IKompisTranslations
	): IConfigurationSummaryToastMessage {
		const label =
			'translations' in localizedInformationOrTranslations
				? localizedInformationOrTranslations.translations.addToShoppingBagAndListErrorMessage
				: localizedInformationOrTranslations.addToShoppingBagAndListErrorMessage;

		return {
			label
		};
	}
}
